import React from "react";
import leaderPortrait2 from "../assets/3.png";
import leaderPortrait3 from "../assets/2.png";
import leaderPortrait4 from "../assets/3.png";
import leadershipCityBanner from "../assets/landscape-city-center-with-many-buildings.jpg";
import leadershipTowerImage from "../assets/vertical-shot-white-building-clear-sky.png";

const leaders = [
  {
    name: "Sunil Khatri",
    role: "Managing Director",
    image: leaderPortrait2,
    description:
      "Started his entrepreneurial journey at just 17, Sunil Khatri brings powerful cross-industry experience, vision, and purpose-driven leadership to Dhanvanti Luxury Builders. His core belief — growth is meaningful only when it uplifts people and communities — defines his approach to business.",
  },
  {
    name: "Mohit Khatri",
    role: "Director",
    image: leaderPortrait3,
    description:
      "A dynamic entrepreneur with a deeply rooted business lineage, Mohit Khatri brings a rare blend of vision, versatility, and social responsibility to Dhanvanti Luxury Builders. His initiatives focus on detail and commitment to delivery.",
  },
  {
    name: "Ritvik Khatri",
    role: "Director",
    image: leaderPortrait4,
    description:
      "An internationally educated professional and Brunel University London graduate, Ritvik Khatri brings a global perspective and analytical expertise to Dhanvanti Luxury Builders. His focus on technology-driven decisions, process optimization, and modern systems supports the company's future-ready growth.",
  },
];

function LeadershipPage() {
  return (
    <main>
      <section className="leadership-section">
      <div className="container">
        <h1 className="leadership-title">
          The <span>Visionaries</span> behind <span>Dhanvanti</span>
        </h1>

        <div className="leaders-grid">
          {leaders.map((leader) => (
            <article key={leader.name} className="leader-card">

              <div className="leader-image-wrapper">
                <div className="leader-bg-shape"></div>
                <img src={leader.image} alt={leader.name} />
              </div>

              <div className="leader-content">
                <h3 className="leader-name">{leader.name}</h3>
                <p className="leader-role">{leader.role}</p>
                <p className="leader-description">
                  {leader.description}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>

            <div className="leadership-banner" >
              <img src={leadershipCityBanner} alt="City skyline" />
            </div>
            <div className="leadership-trust">
              <h2 className="section-title center">
                Why Trust <br></br><span>Our Visionaries</span>
              </h2>
              <h2 style={{color: 'white', fontSize: '14px', marginLeft: '100px', fontWeight: '400'}}>
                Our leadership combines decades of experience, strong ethics, and a focus on long-term value. Every decision is driven by transparency, quality, and trust.
              </h2>
            </div>

          <section className="leadership-trust-1 bg_image">
            <div className="container trust-layout">
            {/* LEFT COLUMN */}
            <div className="trust-column left">
              <div className="trust-item">
                <h3>Experience</h3>
                <p>Combined decades of expertise across real estate, finance, and business development</p>
              </div>

              <div className="trust-item">
                <h3>Commitment</h3>
                <p>Dedicated to delivering value and maintaining the highest standards consistently</p>
              </div>
            </div>

            {/* CENTER TOWER */}
            <div className="trust-center">
              <div className="tower-shape">
                <img src={leadershipTowerImage} alt="Residential tower" />
              </div>
            </div>

            {/* RIGHT COLUMN */}
            <div className="trust-column right">
              <div className="trust-item">
                <h3>Transparency</h3>
                <p>Open communication and accountability in all dealings and decision-making</p>
              </div>

              <div className="trust-item">
                <h3>Integrity</h3>
                <p>Ethics and honesty are non-negotiable in everything we do</p>
              </div>
            </div>
            </div>
        </section>

      <section className="section about-contact">
        <div className="container about-contact-inner">
          <div className="about-contact-text">
            <h3 className="eyebrow">Get in</h3>
            <h3 className="about-heading">Touch</h3>
            <p>
              Speak with our team to understand more about our leadership,
              vision, and upcoming developments.
            </p>
          </div>
          <div className="about-contact-card">
            <h4>Book a Site Visit Now</h4>
            <p className="contact-subtitle">Fill in the form.</p>
            <form className="contact-form" onSubmit={(e) => e.preventDefault()}>
              <div className="form-row">
                <div className="form-field">
                  <input type="text" placeholder="First name" />
                </div>
                <div className="form-field">
                  <input type="text" placeholder="Last name" />
                </div>
              </div>
              <div className="form-row">
                <div className="form-field">
                  <input type="email" placeholder="Email address" />
                </div>
                <div className="form-field">
                  <input type="tel" placeholder="Phone" />
                </div>
              </div>
              <div className="form-field">
                <textarea
                  rows="3"
                  placeholder="Meaasge Share any details you would like us to know."
                />
              </div>
              <div className="form-actions">
                <button type="submit" className="btn-primary">
                  Request to call back
                </button>
              </div>
            </form>
          </div>
        </div>
      </section>
    </main>
  );
}

export default LeadershipPage;

